import React, { useEffect } from "react";
import { Col, List, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import NoRecordFound from "../NoRecordFound";
import { useDispatch } from "react-redux";
import { storeLabelsValue, storeProductReleaseEnumValue } from "../../store/products/productsActions";
import { storeLabels } from "../../store/labels/labelsActions";
import { getLabels } from "../../store/labels/labelsAsyncActions";

interface Props {
  text: any;
  listData: any;
}

const LabelsListing = (props: Props) => {
  const dispatch = useDispatch()
  const { listData, text } = props;
  const handleClick = (props: any) => {
    // const nameFilter = '';
    // const Qparams = nameFilter === "" ? "" : "?name=" + nameFilter
    // dispatch(getLabels(Qparams))
    
    const encoded: any = encodeURI(props)
    dispatch(storeLabelsValue(encoded))
    dispatch(storeProductReleaseEnumValue(null));
  }
 
 
  return (
    <div className="labels-listing" >
      <Row>
        <Col sm={24} lg={6} className="col-heading">
          <Typography.Title
            className={text === "W" ? "main-label main-label-W" : "main-label"}
            level={2}
          >
            {text}
          </Typography.Title>
        </Col>
        <Col sm={24} lg={18}>
          <List
            dataSource={listData}
            locale={{ emptyText: <NoRecordFound /> }}
            renderItem={(item: any) => {
              const encoded = encodeURIComponent(item?.name)
              return (
                <List.Item key={`filterLabel_${item?.id}`} onClick={() => handleClick(item?.name)} >
                  {/* <Link to={`/releases?labelId=${item?.id}`}>{item?.name}</Link> */}
                  <Link to={`/releases?labelName=${encoded}`}>{item?.name}</Link>
                </List.Item>
              )
            }
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default LabelsListing;
